import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95b8d350"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Ces informations apparaîtront sur votre profil public", -1))
const _hoisted_3 = { class: "field-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Firstname" }, "Prénom *", -1))
const _hoisted_5 = { class: "field-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Lastname" }, "Nom de famille *", -1))
const _hoisted_7 = { class: "field-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Birthday" }, "Date de naissance", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("form", {
    id: _ctx.id,
    class: "vertical"
  }, [
    _createElementVNode("fieldset", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.firstname.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Firstname",
          onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ValidateForm && _ctx.ValidateForm(...args))),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ValidateForm && _ctx.ValidateForm(...args))),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ValidateForm && _ctx.ValidateForm(...args))),
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.firstname) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.firstname != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.firstname]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.lastname.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Lastname",
          onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.ValidateForm && _ctx.ValidateForm(...args))),
          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.ValidateForm && _ctx.ValidateForm(...args))),
          onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.ValidateForm && _ctx.ValidateForm(...args))),
          type: "text",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.lastname) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.lastname != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.lastname]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.birthday.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Birthday",
          onFocus: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.ValidateForm && _ctx.ValidateForm(...args))),
          onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.ValidateForm && _ctx.ValidateForm(...args))),
          onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.ValidateForm && _ctx.ValidateForm(...args))),
          type: "date",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.birthday) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.birthday != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.birthday]
        ]),
        _hoisted_8
      ])
    ])
  ], 8, _hoisted_1))
}